import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './app.css';
import './bootstrap.css';
import RouterProvider from 'Providers/RoutesProvider/RoutesProvider';
import AlertProvider from './Providers/AlertProvider/AlertProvider';
import ModalProvider from 'Providers/ModalProvider';
import { socketStore } from 'store/mobx/socket.store';
import { useEffect } from 'react';
import { listStore } from 'store/mobx/list.store';

const App = () => {
  useEffect(() => {
    socketStore.connect();
    listStore.init();
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      <AlertProvider>
        <RouterProvider />
        <ModalProvider />
      </AlertProvider>
    </DndProvider>
  );
};

export default App;
